import {_utils, viewportChecker} from "../../../utils/_utils.js";
import {_state} from "../../../state/state.js";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";


export const blogContentMenu = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.content-menu-js', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section, sectionIndex) => {
    const contentContainer = section.querySelector('.content-container-js');
    const menuItems = section.querySelectorAll('.menu-content-container-js ul li a');
    const siteHeader = document.querySelector('header');

    const targetSections = Array.from(menuItems)
        .map(link => {
            const href = link.getAttribute('href');
            if (href && href.startsWith('#')) {
                const targetId = href.slice(1);
                return contentContainer.querySelector(`#${targetId}`);
            }
            return null;
        })
        .filter(el => el !== null);

    menuItems.forEach(link => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');

            if (href && href.startsWith('#')) {
                const targetId = href.slice(1);
                const targetElement = contentContainer.querySelector(`#${targetId}`);

                if (targetElement) {
                    e.preventDefault();
                    _utils.scrollToElement(targetElement)
                }
            }
        });
    });

    let stickyTrigger = null;
    function createScrollAnimations() {
        if (stickyTrigger) {
            stickyTrigger.kill();
            stickyTrigger = null;
        }

        if (window.innerWidth >= 1024) {
            const stickyBlock = section.querySelector(".privacy-policy-page__menu");
            const percentOffset = 0.15;
            const stickyHeight = stickyBlock.offsetHeight;
            const windowHeight = window.innerHeight;
            const offset = windowHeight * percentOffset;
            const scrollDistance = stickyHeight + offset - windowHeight;

            stickyTrigger = ScrollTrigger.create({
                trigger: section,
                start: `top top+=${offset}`,
                end: `+=${scrollDistance}`,
                pin: stickyBlock,
                pinSpacing: false,
                // markers: true,
            });

        }
    }

    createScrollAnimations();

    const highlightActiveLink = () => {
        const headerHeight = siteHeader.offsetHeight;
        let currentIndex = 0;

        targetSections.forEach((section, index) => {
            const sectionTop = section.getBoundingClientRect().top - headerHeight;
            if (sectionTop <= 150) {
                currentIndex = index;
            }
        });

        menuItems.forEach((link, index) => {
            link.classList.toggle('active', index === currentIndex);
        });
    };

    window.addEventListener('scroll', highlightActiveLink);
    highlightActiveLink();

    // resize
    const rebuildFunc = () => {
        if(_state.isUserActive){
            createScrollAnimations();
        }
    }

    _utils.rebuildComponentsOnResize(rebuildFunc);
}